import config from 'src/config';
import { ResponseDto } from 'src/dtos/common/responseDto';
import { getData } from 'src/utils/axios/serverHelper';
import { formatDate } from 'src/utils/string/stringUtil';
import { SAL3050_R01DetailDto, SAL3050_R01Filter, SAL3050_R01HeaderDto } from './Dto_SAL3050_R01';

const baseUrl = `${config.apiUrl}/SAL3050_R01`;

const getParams = (filter: Partial<SAL3050_R01Filter>) => ({
    compCd:    filter.compCd    || undefined,
    startDate: filter.dateRange?.from ? formatDate(filter.dateRange.from) : undefined,
    endDate:   filter.dateRange?.to   ? formatDate(filter.dateRange.to)   : undefined,
    areaCd:    filter.areaCd    || undefined,
    customCd:  filter.customCd  || undefined,
});

export const getSAL3050_R01HeaderList = async (
    option: string,
    filter: Partial<SAL3050_R01Filter>
) => {
    const url = `${baseUrl}/header/${option}`;
    return await getData<ResponseDto<SAL3050_R01HeaderDto[]>>(url, { params: getParams(filter) });
};

export const getSAL3050_R01DetailList = async (
    option: string,
    filter: Partial<SAL3050_R01Filter>
) => {
    const url = `${baseUrl}/detail/${option}`;
    return await getData<ResponseDto<SAL3050_R01DetailDto[]>>(url, { params: getParams(filter) });
};
